function getBreakpoint(el) {
  const element = el || document.body;

  if (!window.getComputedStyle) return '';

  return window
    .getComputedStyle(element, ':before')
    .getPropertyValue('content')
    .replace(/'|"/g, '');
}

function matchesElement(el, selector) {
  if (el.matches) return el.matches(selector);
  if (el.msMatchesSelector) return el.msMatchesSelector(selector);
  return false;
}

export default {
  breakpoint(el) {
    return getBreakpoint(el);
  },

  isMobile(el) {
    return getBreakpoint(el) === 'mobile';
  },

  closest(el, selector) {
    if (!el) return null;
    if (el.closest) return el.closest(selector);

    let node = el;

    while (node && node.nodeType === 1) {
      if (matchesElement(node, selector)) return node;
      node = node.parentElement;
    }

    return null;
  },

  forEach(list, fn) {
    Array.prototype.forEach.call(list, fn);
  },
};
